/*
 * cadabra-header-enhancements.js
 * ----------------------------------------------------------------------------
 * Header UX enhancements injected without touching sections/header.liquid.
 *
 *   1. Primary CTA pair    — "Register Business" and "Talk to Sales" placed
 *                            inside the header's right-hand utility area on
 *                            desktop, and inside the open hamburger menu on mobile.
 *   2. Cart-drawer a11y    — toggles aria-hidden / inert on <cart-drawer>
 *                            based on the visibility:hidden style flip used
 *                            by the existing cart.js. Open/close hooks the
 *                            existing custom element's .open() / .close().
 * ----------------------------------------------------------------------------
 * No-op on pages that don't have a header (cart page, etc.).
 */

(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 780;
  var CART_DRAWER_TAG = 'cart-drawer';

  // ---------------------------------------------------------------------------
  // Element builders
  // ---------------------------------------------------------------------------

  function makeCTAs() {
    var wrap = document.createElement('div');
    wrap.className = 'cadabra-header-ctas';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Primary actions');
    wrap.innerHTML =
      '<a class="btn btn-color cadabra-header-ctas__quote" href="/pages/enterprise-procurement">' +
        '<span>Register Business</span>' +
      '</a>' +
      '<a class="btn btn--secondary cadabra-header-ctas__sales" href="https://zbooking.in/DtLNb" target="_blank" rel="noopener">' +
        '<span>Talk to Sales</span>' +
      '</a>';
    return wrap;
  }

  // ---------------------------------------------------------------------------
  // Header insertion
  // ---------------------------------------------------------------------------

  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width > 0 && r.height > 0) return true;
    // Walk up the chain — if any ancestor has display:none we count it as hidden.
    var node = el;
    while (node && node.tagName !== 'BODY') {
      if (getComputedStyle(node).display === 'none') return false;
      node = node.parentElement;
    }
    return false;
  }

  function pickVisible(nodeList) {
    for (var i = 0; i < nodeList.length; i++) if (isVisible(nodeList[i])) return nodeList[i];
    return nodeList[0] || null;
  }

  function findHeaderUtilityArea() {
    // Prefer the desktop cart icon (id="cart-icon-bubble") and skip mobile (`--mobile`
    // suffix) which sits inside .header__mobile and is display:none on desktop.
    var cartCandidates = document.querySelectorAll(
      'header #cart-icon-bubble, sticky-header #cart-icon-bubble, header a[href$="/cart"], sticky-header a[href$="/cart"]'
    );
    var cartLink = pickVisible(cartCandidates);
    if (cartLink) return { container: cartLink.parentElement, cartLink: cartLink };

    var actionCandidates = document.querySelectorAll(
      '.header__icons, .header__actions, header .grid > :last-child'
    );
    var actions = pickVisible(actionCandidates);
    return { container: actions, cartLink: null };
  }

  function findMobileMenuRoot() {
    // Theme exposes a mobile drawer via <menu-drawer> or .mobile-menu / .menu-drawer.
    return (
      document.querySelector('menu-drawer .menu-drawer__inner-container') ||
      document.querySelector('menu-drawer') ||
      document.querySelector('.menu-drawer') ||
      document.querySelector('.mobile-menu') ||
      null
    );
  }

  function injectHeader() {
    if (document.querySelector('.cadabra-header-ctas')) return; // already injected

    var spot = findHeaderUtilityArea();
    if (!spot || !spot.container) {
      console.debug('[cadabra-header-enhancements] no insertion spot found, skipping');
      return;
    }

    var ctas = makeCTAs();

    // Place CTAs BEFORE the icon cluster so they read first.
    spot.container.insertBefore(ctas, spot.container.firstChild);

    // Clone CTAs into mobile drawer if present.
    var drawer = findMobileMenuRoot();
    if (drawer) {
      var mobileCTAs = makeCTAs();
      mobileCTAs.classList.add('cadabra-header-ctas--mobile');
      drawer.appendChild(mobileCTAs);
    }
  }

  // ---------------------------------------------------------------------------
  // Cart drawer a11y
  // ---------------------------------------------------------------------------

  function setupCartDrawerA11y() {
    var drawer = document.querySelector(CART_DRAWER_TAG);
    if (!drawer) return;

    // Start closed.
    setClosed(drawer);

    var observer = new MutationObserver(function () {
      var visible =
        drawer.classList.contains('active') ||
        drawer.classList.contains('is-open') ||
        drawer.getAttribute('open') !== null ||
        getComputedStyle(drawer).visibility === 'visible';
      if (visible) setOpen(drawer);
      else setClosed(drawer);
    });
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'style', 'open', 'data-open'],
    });

    window.cadabraOpenCart = function () {
      if (typeof drawer.open === 'function') drawer.open();
      setOpen(drawer);
    };
  }

  function setOpen(el) {
    el.removeAttribute('aria-hidden');
    el.removeAttribute('inert');
  }
  function setClosed(el) {
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('inert', '');
  }

  // ---------------------------------------------------------------------------
  // Bootstrap
  // ---------------------------------------------------------------------------

  function ready(fn) {
    if (document.readyState === 'loading')
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    injectHeader();
    setupCartDrawerA11y();
    setTimeout(injectHeader, 600);
  });
})();
